import LoaderEGanesha from "@/components/LoaderEGanesha";
import SystemMaintenancePage from "@/pages/maintenance/SystemMaintenancePage";
import { getMaintenanceStatus } from "@/services/getData";
import { useQuery } from "@tanstack/react-query";
import { Outlet } from "react-router-dom";

export default function SystemMaintenanceMiddleware() {
  const { data, isLoading } = useQuery({
    queryKey: ["maintenanceStatus"],
    queryFn: getMaintenanceStatus,
  });

  if (isLoading) return <LoaderEGanesha />;

  if (data?.system_maintenance) return <SystemMaintenancePage />;

  return <Outlet />;
}
